<div class="inactive-widget-footer">
  <div class="arrows-div">
    <div class="left-arrow-div">
      <span>CTRL + ALT + J</span>
    </div>
    <div class="right-arrow-div">
      <span>CTRL + ALT + L</span>
    </div>
  </div>
  <div class="inactive-editor-message">{{ text | appHtmlToText }}</div>
</div>
